var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFast = function SvgFast(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 34919"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4717",
    d: "M2 22C2 16.4142 2 13.6213 2.78563 11.3761C4.1928 7.35464 7.35464 4.1928 11.3761 2.78563C13.6213 2 16.4142 2 22 2C27.5858 2 30.3787 2 32.6239 2.78563C36.6454 4.1928 39.8072 7.35464 41.2144 11.3761C42 13.6213 42 16.4142 42 22C42 27.5858 42 30.3787 41.2144 32.6239C39.8072 36.6454 36.6454 39.8072 32.6239 41.2144C30.3787 42 27.5858 42 22 42C16.4142 42 13.6213 42 11.3761 41.2144C7.35464 39.8072 4.1928 36.6454 2.78563 32.6239C2 30.3787 2 27.5858 2 22Z",
    fill: "#FC3F1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M15.5121 31.9018L23.9696 25.1895C24.3164 24.9571 24.1731 24.4717 23.746 24.4184L23.1556 24.3432C22.7547 24.3022 22.5929 23.8648 22.8889 23.605L27.5169 19.7226C27.8098 19.4765 27.6402 19.039 27.2394 18.9843L25.2661 18.7383C24.8653 18.6904 24.7111 18.2598 24.9886 18.0083L30.9471 12.7314C31.2323 12.4812 31.0704 12.0478 30.6696 12L22.7486 12.0588C22.5636 12.0369 22.3786 12.1066 22.2768 12.242L17.2973 18.6986C17.0907 18.9611 17.2711 19.3234 17.6272 19.3685L19.4109 19.5954C19.7763 19.6364 19.9505 20.0028 19.7501 20.2653L16.3353 24.6809C16.1349 24.9475 16.3122 25.3098 16.6698 25.3562L18.3502 25.5681C18.7094 25.616 18.8898 25.9755 18.6894 26.238L14.8152 31.3276C14.5069 31.7281 15.0773 32.2025 15.509 31.9086L15.5121 31.9018Z",
    fill: "white"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFast, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fast.d761e5ae.svg";
export { ForwardRef as ReactComponent };